import { httpCreate } from './http';

const http = httpCreate('/srv/user-account');

export const userAccount = {
	getInfo() {
		return http.get('');
	},
	addInfo(data) {
		return http.post(`/add`, data);
	},
	unbind() {
		return http.get(`/unbind`);
	},
};
